import { r as registerInstance, h, H as Host } from './index-aa456b4c.js';

const fdsTabsCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}.fds-tabs{display:inline-flex;background-color:rgba(12, 72, 153, 0.0475);border-radius:32px;overflow:auto;max-width:100%}.fds-tabs--block{display:flex;justify-content:space-between}.fds-tabs--block .fds-tabs__item{flex:1;display:flex}.fds-tabs--block .fds-tabs__item a{flex:1}.fds-tabs--block .fds-tabs__item button{flex:1}";

const FdsTabs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.block = false;
  }
  render() {
    const classes = {
      'fds-tabs': true,
      'fds-tabs--block': this.block
    };
    return (h(Host, { class: classes }, h("slot", null)));
  }
};
FdsTabs.style = fdsTabsCss;

export { FdsTabs as fds_tabs };
